module.exports = __webpack_public_path__ + "img/vertical_3_1_9005.0f430076.png";